import curriculoImg from '../../img/curriculo.png';
import solicitacaoImg from '../../img/solicitacao-cargo-desligamento.png';
import aprovacaoImg from '../../img/aprovacao-cargo-salario.png';
import fluxoNfeErpImg from '../../img/FluxoNFe ERP.png';
import fluxoCobrancaImg from '../../img/fluxodecobranca.png';
import './N8nExample.css';

const examples = [
  {
    id: 'curriculo',
    image: curriculoImg,
    alt: 'Fluxo n8n: captura de currículo por e-mail, gravação no banco e resposta automática ao candidato',
    title: 'Captura de currículo por e-mail',
    paragraphs: [
      'Esse fluxo com n8n captura o currículo recebido por e-mail e grava no banco de dados.',
      'Caso o e-mail tenha algum problema, o sistema retorna automaticamente para o candidato e pede para reenviar.',
      'Se tudo ocorrer com sucesso, envia a mensagem de currículo enviado com sucesso.',
    ],
  },
  {
    id: 'solicitacao',
    image: solicitacaoImg,
    alt: 'Fluxo n8n: solicitação de mudança de cargo, salário ou desligamento',
    title: 'Solicitação de cargo, salário ou desligamento',
    paragraphs: [
      'Esse fluxo recebe a solicitação de mudança de cargo, alteração de salário ou desligamento.',
      'Com base no tipo de solicitação, o n8n separa o processo: gera o HTML correspondente e envia o e-mail adequado.',
      'No final, retorna a confirmação da solicitação para o sistema de origem.',
    ],
  },
  {
    id: 'aprovacao',
    image: aprovacaoImg,
    alt: 'Fluxo n8n: aprovação ou recusa de solicitação de cargo e salário com envio de e-mail e registro em Excel',
    title: 'Aprovação ou recusa de cargo e salário',
    paragraphs: [
      'Esse fluxo trata a resposta da solicitação de cargo e salário: gera o HTML e envia por e-mail a aprovação ou a recusa.',
      'Atualiza o status da solicitação no banco de dados via API e registra a informação na planilha Excel.',
      'Assim, o RH e o gestor acompanham o processo com histórico e comunicação automática.',
    ],
  },
  {
    id: 'nfe-erp',
    image: fluxoNfeErpImg,
    alt: 'Fluxo NF-e: recebimento por e-mail ou API, validação e integração até o ERP — solução contábil',
    title: 'Fluxo NF-e — E-mail/API até ERP',
    badge: 'Solução contábil',
    paragraphs: [
      'Automação para escritórios e departamentos contábeis: as notas fiscais eletrônicas chegam por e-mail ou API e seguem um fluxo padronizado até o ERP.',
      'O processo valida, organiza e registra os documentos, reduzindo digitação manual e retrabalho na entrada de NF-e.',
      'Ideal para quem precisa de rastreabilidade, menos erros e integração contínua entre canais de recebimento e o sistema contábil.',
    ],
  },
  {
    id: 'cobranca-documentos',
    image: fluxoCobrancaImg,
    alt: 'Fluxo de cobrança automática de documentos pendentes por e-mail',
    title: 'Fluxo Cobrança de Documentos Pendentes',
    paragraphs: [
      'Automação que monitora documentos pendentes e dispara cobranças por e-mail de forma padronizada.',
      'O fluxo aplica regras de prazo e destinatário, registra cada envio e mantém o acompanhamento atualizado.',
      'Reduz trabalho manual da equipe e acelera o recebimento de documentos que travam processos contábeis, fiscais ou administrativos.',
    ],
  },
];

function N8nExample() {
  return (
    <section id="automacao-n8n" className="section n8n-example">
      <div className="container">
        <div className="section-header">
          <h2>N8N e Inteligência Artificial</h2>
          <p>Exemplos reais de fluxos com n8n: e-mail, RH, aprovações e integração com banco de dados.</p>
        </div>

        <div className="n8n-examples-list">
          {examples.map((example) => (
            <article key={example.id} className="n8n-example-content">
              <h3 className="n8n-example-title">{example.title}</h3>
              {example.badge && (
                <p className="n8n-example-badge">{example.badge}</p>
              )}

              <figure className="n8n-figure">
                <img src={example.image} alt={example.alt} />
              </figure>

              <div className="n8n-description">
                {example.paragraphs.map((text) => (
                  <p key={text}>{text}</p>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default N8nExample;
